/* hyfb kit behaviour: query string on PDP links, in-page scroll links, midnight timer, rails + arrows,
   facts modal, FAQ "view more", and the lander sticky CTA (hands over to hbo-sticky below the buy box). */
(function () {
  if (window.__hyfb) return;
  window.__hyfb = 1;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var qs = location.search;
    if (qs) {
      document.querySelectorAll('a[data-hyfb-qs]').forEach(function (a) {
        var h = a.getAttribute('href') || '';
        if (h && h.charAt(0) !== '#' && h.indexOf('?') < 0) a.setAttribute('href', h + qs);
      });
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-hyfb-go]');
      if (!a) return;
      var t = document.getElementById((a.getAttribute('href') || '').slice(1));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 16, behavior: 'smooth' });
    });

    /* timer: counts to the visitor's local midnight, like the store's offer bar */
    var timers = document.querySelectorAll('[data-hyfb-timer]');
    if (timers.length) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
        var d = Math.max(0, Math.floor((end - now) / 1000));
        var h = pad(Math.floor(d / 3600)), m = pad(Math.floor(d % 3600 / 60)), s = pad(d % 60);
        timers.forEach(function (t) {
          t.querySelector('[data-h]').textContent = h; t.querySelector('[data-m]').textContent = m; t.querySelector('[data-s]').textContent = s;
        });
      };
      tick(); setInterval(tick, 1000);
    }

    /* rails */
    document.querySelectorAll('[data-hyfb-car]').forEach(function (car) {
      var rail = car.querySelector('[data-hyfb-rail]');
      var prev = car.querySelector('[data-hyfb-prev]'), next = car.querySelector('[data-hyfb-next]');
      if (!rail) return;
      function step() {
        var c = rail.firstElementChild; if (!c) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        var w = c.getBoundingClientRect().width + gap;
        return Math.max(w, Math.floor(rail.clientWidth / w) * w);
      }
      function paint() {
        car.classList.toggle('is-static', rail.scrollWidth <= rail.clientWidth + 4);
        if (!prev || !next) return;
        prev.disabled = rail.scrollLeft < 4;
        next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      var raf = 0;
      rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paint(); }); }, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    });

    /* modal */
    var lastFocus = null;
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-hyfb-open]');
      if (o) {
        var m = document.getElementById(o.getAttribute('data-hyfb-open'));
        if (m) { lastFocus = o; m.hidden = false; document.documentElement.style.overflow = 'hidden'; var x = m.querySelector('[data-hyfb-close]'); if (x) x.focus(); }
        return;
      }
      var modal = e.target.closest && e.target.closest('.hyfb-modal');
      if (modal && (e.target === modal || e.target.closest('[data-hyfb-close]'))) {
        modal.hidden = true; document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.hyfb-modal:not([hidden])').forEach(function (m) { m.hidden = true; document.documentElement.style.overflow = ''; });
    });

    /* FAQ view more */
    document.querySelectorAll('[data-hyfb-morebtn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('.hyfb-faq');
        box.querySelectorAll('[data-hyfb-more]').forEach(function (d) { d.hidden = false; });
        b.remove();
      });
    });

    /* sticky: on in the lander half once the hero CTA has scrolled away (phones: as soon as the page
       moves, the ref has no inline hero CTA there); off from the buy box down, where hbo-sticky takes over */
    var st = document.querySelector('[data-hyfb-sticky]');
    if (st) {
      var heroCta = document.querySelector('.hyfb-hero__cta .hyfb-btn');
      var buy = document.querySelector('[data-hbo-hero]');
      var link = st.querySelector('a');
      var on = null, ticking = 0, forced = false;
      /* phones have no inline hero CTA (as in the ref), so like hyt-bp's sticky (leak audit: 72% never
         scroll) the button comes up after 3 seconds even without a scroll */
      setTimeout(function () { forced = true; check(); }, 3000);
      var check = function () {
        ticking = 0;
        var vh = window.innerHeight;
        var inBuy = buy ? buy.getBoundingClientRect().top < vh * 0.85 : false;
        var heroGone;
        if (heroCta && heroCta.offsetParent !== null) heroGone = heroCta.getBoundingClientRect().bottom < 0;
        else heroGone = forced || window.pageYOffset > 40;
        var next = heroGone && !inBuy;
        if (next !== on) {
          on = next; st.classList.toggle('is-on', next);
          document.documentElement.classList.toggle('hyfb-stk-on', next);
          st.setAttribute('aria-hidden', next ? 'false' : 'true');
          if (link) link.tabIndex = next ? 0 : -1;
        }
      };
      window.addEventListener('scroll', function () { if (!ticking) ticking = requestAnimationFrame(check); }, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
  });
})();
